const SET_LOADING = 'SET_LOADING'
const SET_CAMPAIGNS = 'SET_CAMPAIGNS'
const SET_PAGINATION = 'SET_PAGINATION'
const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY'
const SET_DEFAULT_STATE = 'SET_DEFAULT_STATE'
const SET_CURRENCY = 'SET_CURRENCY'
const SET_TRAFFIC_SOURCES = 'SET_TRAFFIC_SOURCES'
export const ADD_CAMPAIGN = 'ADD_CAMPAIGN'
const DELETE_CAMPAIGN = 'DELETE_CAMPAIGN'
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN'

const getDefaultState = () => ({
  campaigns: [],
  searchQuery: '',
  currency: '',
  pagination: {
    currentPage: 1,
    perPage: 1,
    lastPage: 1,
    total: 0,
  },
  trafficSources: [],
  loading: false,
})

export default {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    campaigns: (state) => state.campaigns,
    loading: (state) => state.loading,
    searchQuery: (state) => state.searchQuery,
    pagination: (state) => state.pagination,
    currency: (state) => state.currency,
    trafficSources: (state) => state.trafficSources,
  },
  mutations: {
    [SET_CAMPAIGNS]: (state, campaigns) => (state.campaigns = campaigns),
    [SET_LOADING]: (state, loading) => (state.loading = loading),
    [SET_PAGINATION]: (state, pagination) => (state.pagination = pagination),
    [SET_SEARCH_QUERY]: (state, searchQuery) => (state.searchQuery = searchQuery),
    [ADD_CAMPAIGN]: (state, campaign) => state.campaigns.unshift(campaign),
    [DELETE_CAMPAIGN]: (state, id) =>
      (state.campaigns = state.campaigns.filter((item) => item.id !== id)),
    [UPDATE_CAMPAIGN]: (state, campaign) =>
      (state.campaigns = state.campaigns.map((item) =>
        item.id === campaign.id ? campaign : item,
      )),
    [SET_DEFAULT_STATE]: (state) => Object.assign(state, getDefaultState()),
    [SET_CURRENCY]: (state, currency) => (state.currency = currency),
    [SET_TRAFFIC_SOURCES]: (state, trafficSources) => (state.trafficSources = trafficSources),
  },
  actions: {
    changeSearchQuery({ commit, dispatch, state }, searchQuery) {
      if (state.searchQuery !== searchQuery) {
        commit(SET_SEARCH_QUERY, searchQuery)
        dispatch('fetchCampaigns', { clear: true })
      }
    },
    changePage({ commit, dispatch, state }, page) {
      commit(SET_PAGINATION, { ...state.pagination, currentPage: page })
      dispatch('fetchCampaigns')
    },
  },
}
